import { Fragment, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { getAdAccount } from '../../api/axios/crux/account'

const Jump = () => {
  const { accountId } = useParams()
  const history = useHistory()
  useEffect(() => {
    getAdAccount(accountId)
      .then(() => {
        history.replace(`/${accountId}/dashboard`)
      })
      .catch(() => {
        history.replace('/adaccount/all')
      })
  }, [accountId, history])
  return <Fragment />
}

export default Jump
